
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaiairportcabs() {



    const cardData =
    {
        keyword: 'Pune to Mumbai Airport Cabs',
        heading: 'Platinum24 Cabs: Pune to Mumbai Airport Cabs',
        headingDescription: ' Platinum24 Cabs offers reliable Pune to Mumbai Airport Cabs, ensuring safe and punctual transfers to both Terminal 1 and Terminal 2. Our fleet of hatchbacks, sedans, SUVs, and luxury cars is perfect for solo travelers, families, and corporate clients who value comfort and timely service. With experienced chauffeurs familiar with the Pune–Mumbai expressway, we guarantee smooth travel, on-time airport arrivals, and stress-free pickups even during odd hours. Platinum24 Cabs provides flexible one-way and round-trip options at affordable fares, making your Pune to Mumbai Airport journey convenient, comfortable, and hassle-free.',

        top: 'Top Places to Visit in Mumbai with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924, is Mumbai’s most iconic monument overlooking the Arabian Sea. Constructed in Indo-Saracenic style, it was built to commemorate King George V’s visit. Tourists enjoy boat rides to Elephanta Caves from here. The grand structure becomes stunning at sunrise and evening when lit up. Surrounded by vendors and street food, it’s always lively. Gateway of India is Mumbai’s proud heritage landmark."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also called the ‘Queen’s Necklace,’ is a 3.6 km boulevard along the Arabian Sea. At night, streetlights create a necklace-like glow. Locals and tourists enjoy evening walks, sunsets, and street snacks like bhel puri. The sea breeze makes it refreshing all year. Major festivals and events are also celebrated here. Marine Drive is Mumbai’s most romantic and scenic hangout spot."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "CST, a UNESCO World Heritage Site, is one of India’s most beautiful railway stations. Built in 1887, it showcases Victorian Gothic architecture with intricate carvings and domes. It is a major hub of Mumbai’s lifeline – the local trains. Tourists admire its illuminated façade at night. The station is also a symbol of Mumbai’s heritage and hustle. CST is Mumbai’s architectural masterpiece of history and modern life."
  },
  {
    "title": "Elephanta Caves",
    "description": "Located on Elephanta Island, these UNESCO World Heritage rock-cut caves date back to the 5th–7th centuries. The caves house magnificent sculptures of Lord Shiva, including the famous three-headed Trimurti. A ferry ride from Gateway of India takes visitors here. Surrounded by greenery and sea, it offers a blend of history and adventure. The caves reflect India’s ancient craftsmanship. Elephanta Caves are Mumbai’s spiritual and historical gem."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most popular seaside destination, attracting families, couples, and celebrities. Tourists enjoy horse rides, camel rides, and street food like pav bhaji and gola. Sunsets here are enchanting with golden skies. Many Bollywood stars reside near Juhu, making it famous. It is also a cultural spot for film shoots and festivals. Juhu Beach is Mumbai’s vibrant seaside escape."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple in Prabhadevi is one of India’s most revered shrines dedicated to Lord Ganesha. Built in 1801, it is known for fulfilling devotees’ wishes. Bollywood stars, politicians, and common devotees alike visit regularly. Tuesdays see massive crowds for darshan. The temple’s golden dome and idol’s charisma create a divine aura. Siddhivinayak is Mumbai’s spiritual heart."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is Mumbai’s famous street shopping and food hub near Gateway of India. Tourists shop for jewelry, clothes, handicrafts, and souvenirs at bargain prices. Cafés like Leopold and Café Mondegar add charm. The area is always bustling with locals and foreigners. It combines colonial charm with modern vibrancy. Colaba Causeway is Mumbai’s lively shopping and cultural street."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, located on a tiny islet in the Arabian Sea, is Mumbai’s most famous Islamic shrine. Built in the 15th century, it houses the tomb of Saint Haji Ali. A narrow causeway connects it to the mainland, accessible during low tide. The white marble structure surrounded by sea is breathtaking. People of all faiths visit for blessings. Haji Ali is Mumbai’s symbol of faith and unity."
  },
  {
    "title": "Chowpatty Beach",
    "description": "Girgaon Chowpatty is a lively beach famous for Mumbai’s street food culture. Visitors savor pav bhaji, pani puri, and kulfi under the open sky. It is also known for Ganesh Visarjan celebrations when thousands gather to immerse idols. Families enjoy ferris wheel rides and kids’ activities. Sunsets here are magical. Chowpatty is Mumbai’s fun-filled cultural seaside hub."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "Sanjay Gandhi National Park is one of the world’s largest urban green zones, offering trekking, safaris, and picnics. The park is home to leopards, deer, and birds. Inside the park lie the Kanheri Caves, ancient Buddhist rock-cut caves with viharas and chaityas. Tourists enjoy cycling and boating in the park’s natural setting. It is Mumbai’s mix of heritage and greenery. SGNP and Kanheri Caves are Mumbai’s eco-spiritual retreats."
  }
],



  "services": [
    {
      "name": "Pune to Mumbai Airport Cab Service",
      "description": "Reliable and efficient cab service connecting Pune to Mumbai Airport, designed to ensure timely arrivals and comfortable journeys. Our service features professional drivers familiar with the best routes to avoid traffic delays, clean and well-maintained vehicles, and options ranging from economical to luxury cars. Whether traveling for business or leisure, passengers can expect courteous service and hassle-free airport transfers tailored to their schedule."
    },
    {
      "name": "Airport Transfer Pune to Mumbai",
      "description": "Seamless airport transfer service between Pune and Mumbai, offering punctual pickups and drop-offs with real-time flight tracking. Our dedicated drivers are trained to assist passengers with luggage and provide a smooth travel experience. Choose from various vehicle types including sedans, SUVs, and luxury cars to match your preference and group size. The service also includes transparent pricing, no hidden fees, and 24/7 customer support to cater to early morning or late-night flights."
    },
    {
      "name": "Pune to Mumbai Airport Taxi",
      "description": "Comfortable and secure taxi service from Pune to Mumbai Airport, ideal for solo travelers, families, and corporate clients. Our taxis are sanitized regularly and equipped with GPS navigation for accurate route tracking. Booking is easy and flexible with options for instant confirmation. Drivers prioritize passenger safety and offer courteous assistance, making your journey stress-free and punctual, regardless of your flight timings."
    },
    {
      "name": "Pune Mumbai Airport Cab Booking",
      "description": "Quick and hassle-free cab booking platform for Pune to Mumbai Airport travel. Customers can book cabs online or via phone with instant confirmation and flexible scheduling. Options include economy cars, SUVs, and luxury vehicles, all driven by experienced chauffeurs who prioritize comfort and safety. The service supports customized pick-up points and offers transparent fare estimates based on vehicle type and travel time."
    },
    {
      "name": "Pune to Mumbai Airport Car Rental",
      "description": "Wide range of car rental options for travelers heading from Pune to Mumbai Airport, including both self-drive and chauffeur-driven vehicles. Our rental packages are flexible, covering hourly, daily, and trip-based durations. Perfect for travelers who prefer control over their schedule or need a dedicated driver for convenience. All vehicles are maintained to the highest standards and include 24/7 roadside assistance and customer support."
    },
    {
      "name": "Pune to Mumbai Airport Private Cabs",
      "description": "Exclusive private cab service offering direct transfers between Pune and Mumbai Airport with personalized attention and privacy. Our private cabs provide an elevated travel experience with amenities like bottled water, Wi-Fi, and comfortable seating. Ideal for business executives, families, and those seeking a premium airport transfer solution. Drivers are professionally trained to ensure punctuality, safe driving, and a welcoming atmosphere."
    },
    {
      "name": "Airport Shuttle Pune to Mumbai",
      "description": "Economical and convenient airport shuttle services from Pune to Mumbai, perfect for solo travelers or small groups looking for cost-effective shared rides. The shuttle operates on scheduled timings with multiple pick-up points, ensuring timely arrival at Mumbai Airport. Vehicles are regularly sanitized and managed by experienced drivers familiar with airport protocols and routes, providing a reliable option for airport transfers."
    },
    {
      "name": "Pune to Mumbai Airport Taxi Fare",
      "description": "Transparent and competitive taxi fare details for Pune to Mumbai Airport trips, helping travelers plan their budget effectively. Fare estimates are based on vehicle type, distance, travel time, and any applicable tolls or taxes. No hidden charges or surprise fees. Customers receive a detailed fare breakdown during booking, along with flexible payment options including cash, card, and digital wallets."
    },
    {
      "name": "Pune to Mumbai Airport Cab Charges",
      "description": "Comprehensive overview of cab charges for the Pune to Mumbai Airport route across various vehicle categories including hatchbacks, sedans, SUVs, and luxury cars. Charges include fuel costs, tolls, driver allowance, and service fees. Options for one-way and round-trip packages are available to suit different traveler needs. Our pricing policy ensures affordability without compromising on quality and safety."
    },
    {
      "name": "Best Cab Service Pune to Mumbai Airport",
      "description": "Top-rated cab service recognized for exceptional reliability, comfort, and customer satisfaction on the Pune to Mumbai Airport route. We prioritize timely pickups, professionally trained drivers, well-maintained vehicles, and excellent customer support. Our service caters to business travelers, families, and frequent flyers, providing a seamless and stress-free airport transfer experience."
    },
    {
      "name": "Mumbai Airport Pick-up from Pune",
      "description": "Efficient and courteous pick-up services from Mumbai Airport to Pune with real-time flight monitoring to adjust pick-up timing. Drivers assist with luggage and ensure a smooth, comfortable ride back to Pune. Vehicles range from budget to luxury segments, equipped with amenities such as air conditioning, charging ports, and Wi-Fi to enhance passenger comfort."
    },
    {
      "name": "Pune to Mumbai Airport Drop Taxi",
      "description": "Reliable taxi drop service from Pune to Mumbai Airport designed to get you to your flight on time and with ease. We offer flexible scheduling, professional chauffeurs, and a range of vehicle options suited for solo travelers and groups alike. Safety and cleanliness are prioritized, with all vehicles sanitized regularly and drivers trained in safe driving practices."
    },
    {
      "name": "Pune Mumbai Airport Luxury Cab",
      "description": "Travel in premium style from Pune to Mumbai Airport with our luxury cab service offering high-end vehicles such as Mercedes, BMW, and Audi. Enjoy extra legroom, premium interiors, onboard entertainment, and personalized chauffeur service. Ideal for executives, VIPs, and travelers seeking comfort and exclusivity during their airport transfers."
    },
    {
      "name": "Pune to Mumbai Airport Taxi Online",
      "description": "Convenient online taxi booking platform for Pune to Mumbai Airport trips, offering instant confirmation, fare transparency, and easy payment options. Customers can select preferred vehicle types and add special requests. The service includes 24/7 customer support and live ride tracking to keep passengers informed throughout their journey."
    },
    {
      "name": "Pune to Mumbai Airport One-Way Taxi",
      "description": "Affordable and flexible one-way taxi services from Pune to Mumbai Airport, perfect for travelers who don’t require a return trip. Pay only for the distance traveled with no additional return charges. Vehicles are well-maintained and driven by experienced chauffeurs who ensure timely arrival and a comfortable ride."
    }
  ],
  "tableData": [
    ["Pune to Mumbai Airport Cab Service", "Airport Transfer Pune to Mumbai"],
    ["Pune to Mumbai Airport Taxi", "Pune Mumbai Airport Cab Booking"],
    ["Pune to Mumbai Airport Car Rental", "Pune to Mumbai Airport Private Cabs"],
    ["Airport Shuttle Pune to Mumbai", "Pune to Mumbai Airport Taxi Fare"],
    ["Pune to Mumbai Airport Cab Charges", "Best Cab Service Pune to Mumbai Airport"],
    ["Mumbai Airport Pick-up from Pune", "Pune to Mumbai Airport Drop Taxi"],
    ["Pune Mumbai Airport Luxury Cab", "Pune to Mumbai Airport Taxi Online"],
    ["Pune to Mumbai Airport One-Way Taxi", "—"]
  ],


     "whychoose": [
    {
      "WhyChooseheading": "Reliable Pune to Mumbai Airport Cab Service",
      "WhyChoosedescription": "Platinum24 Cabs ensures timely and hassle-free transfers from Pune to Mumbai Airport."
    },
    {
      "WhyChooseheading": "On-Time Pickups to Catch Your Flight Without Stress",
      "WhyChoosedescription": "Our punctual drivers make sure you reach the airport well in advance of your departure time."
    },
    {
      "WhyChooseheading": "Comfortable and Clean Vehicles for Long Rides",
      "WhyChoosedescription": "Enjoy a smooth and relaxing journey in our well-maintained, air-conditioned cabs."
    },
    {
      "WhyChooseheading": "Fixed and Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Know your fare upfront—our pricing includes fuel, tolls, and driver charges with no surprises."
    },
    {
      "WhyChooseheading": "Experienced Drivers Familiar with Airport Routes",
      "WhyChoosedescription": "Our drivers are well-versed with the best routes to Mumbai Airport, avoiding delays and traffic."
    },
    {
      "WhyChooseheading": "24/7 Service for Early Morning or Late Night Flights",
      "WhyChoosedescription": "We operate round the clock to accommodate your airport travel at any hour."
    },
    {
      "WhyChooseheading": "Easy Online Booking and Ride Tracking",
      "WhyChoosedescription": "Book your cab in minutes and track its location in real-time for added peace of mind."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options to Suit Your Travel Needs",
      "WhyChoosedescription": "Choose from hatchbacks, sedans, or SUVs based on your luggage and group size."
    }
  ]



















    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs offer cab services from Pune to Mumbai Airport?',
        answer: 'Yes, Platinum24 Cabs provides reliable and comfortable cab services for travel from Pune to Mumbai Airport.',
    },
    {
        question: 'How can I book a Pune to Mumbai Airport cab with Platinum24 Cabs?',
        answer: 'You can book your Pune to Mumbai Airport cab easily through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Mumbai Airport trips?',
        answer: 'We offer a range of vehicles including sedans, SUVs, and premium cars to suit your travel preferences and group size.',
    },
    {
        question: 'Are the drivers experienced for the Pune to Mumbai Airport route?',
        answer: 'Yes, all our drivers are professional, experienced, and well-versed with the Pune to Mumbai Airport route for timely and safe travel.',
    },
    {
        question: 'Can I book a round trip cab for Pune to Mumbai Airport and back?',
        answer: 'Absolutely! We provide round-trip cab services with flexible scheduling to fit your travel plans.',
    },
    {
        question: 'What is included in the fare for Pune to Mumbai Airport cab services?',
        answer: 'The fare covers vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for extra stops or waiting time.',
    },
    {
        question: 'Can I customize pickup and drop-off locations for Pune to Mumbai Airport rides?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points for a seamless journey.',
    },
    {
        question: 'Are safety measures in place for Pune to Mumbai Airport cab rides?',
        answer: 'All vehicles are regularly sanitized, and our drivers adhere to strict safety protocols to ensure your protection.',
    },
    {
        question: 'Is it possible to hire a cab for multiple days for Pune to Mumbai Airport travel?',
        answer: 'Yes, we offer hourly and multi-day rental packages tailored to your travel needs.',
    },
    {
        question: 'Does Platinum24 Cabs provide corporate taxi services from Pune to Mumbai Airport?',
        answer: 'Yes, we offer customized corporate travel solutions including priority support and flexible billing for this route.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Vikram Shah',
        feedback: 'The Pune to Mumbai Airport cab service by Platinum24 Cabs was punctual and comfortable. Highly recommended!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Kavita Deshmukh',
        feedback: 'Booking a cab from Pune to Mumbai Airport was hassle-free with Platinum24 Cabs. The driver was professional and the ride smooth.',
        rating: 5,
    },
];

































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];









const puneToMumbaiAirportCabsSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Airport Cabs",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-mumbai-airport-cabs.jpg",
  "description": "Book reliable Pune to Mumbai Airport cab service with Platinum24 Cabs. Enjoy comfortable airport transfers, private cabs, luxury options, and 24/7 customer support.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "8500",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-mumbai-airport-cabs"
  }
};





    return (
        <div>

<Helmet>
  <title>Pune to Mumbai Airport Cabs | Airport Transfer & Private Taxi | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book reliable Pune to Mumbai Airport cab service with Platinum24 Cabs. Enjoy comfortable airport transfers, private cabs, luxury options, and 24/7 customer support."
  />
  <meta
    name="keywords"
    content="Pune to Mumbai Airport Cab Service, Airport Transfer Pune to Mumbai, Pune to Mumbai Airport Taxi, Pune Mumbai Airport Cab Booking, Pune to Mumbai Airport Car Rental, Pune to Mumbai Airport Private Cabs, Airport Shuttle Pune to Mumbai, Pune to Mumbai Airport Taxi Fare, Pune to Mumbai Airport Cab Charges, Best Cab Service Pune to Mumbai Airport, Mumbai Airport Pick-up from Pune, Pune to Mumbai Airport Drop Taxi, Pune Mumbai Airport Luxury Cab, Pune to Mumbai Airport Taxi Online, Pune to Mumbai Airport One-Way Taxi"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToMumbaiAirportCabsSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/17.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomumbaiairportcabs;